export const Channels = {
  BANNERS: 'banners',
  BELL: 'bell',
  BROWSER: 'browser',
  FLOATING: 'floating',
  PRE_PERMISSION: 'pre-permission',
  SIDEBAR: 'sidebar',
  TEASE: 'tease'
};